  <template>

    <div class="row justify-content-between align-items-top">

      <div class="margins col-lg-4">
        <div class="row">
          <div class="col-xs-1 icon-width pl-3">
            <i class="material-icons text-jeff-yellow">place</i>
          </div>

          <div class="col-xs-11">  
            <div>         
              Friendship Park Board District
            </div>
            <div>
              PO Box 4004
            </div>
            <div>
              Steubenville, OH 43952
            </div>
          </div>
        </div>
      </div>

      <div class="margins col-lg-4">
        <i class="material-icons icon-padding">call</i> (740) 733-7941<br />
        <!-- <i class="material-icons icon-padding">email</i> <a class="link-hover" href="mailto:friendshippark@jeffersoncountyoh.com">friendshippark@jeffersoncountyoh.com</a><br /> -->
      </div>

      <div class="margins col-lg-auto">
        <div class="row">
          <div class="col-xs-1 icon-width pl-3">
            <i class="material-icons text-success">place</i>
          </div>

          <div class="col-xs-11">  
            <div>         
              <a href="https://www.google.com/maps/@40.2900521,-80.785171,15z" target="blank">Directions To Park</a>
            </div>
          </div>
        </div>
      </div>

    </div>

</template>

<script>

export default {
  components: {},
  data () {
    return {}
  }
}
</script>

<style scoped>

.icon-padding {
  margin-right: 15px;
}

.icon-width {
  margin-right: 10px;
}

.margins {
  margin: 20px 0 20px 0px;
}

</style>
